import { get, post } from "../lib/axios";
import { SERVER_URL, PUBLIC_URL } from "../config";

class FoodService {
	static async getFoodData(xookId: string): Promise<any> {
		return Promise.all([this.getStaticData(xookId), this.getDynamicFoodData(xookId)])
			.then((responses) => {
				if (responses[0].data && responses[1].data) {
					return { data: { ...responses[0].data, ...responses[1].data } };
				} else
					return { error: responses[0].error || responses[1].error, errorCode: responses[0].errorCode || responses[1].errorCode };
			})
			.catch((error) => {
				return { error: "" };
			});
	}

	// NOTE: Xook Headers are not to be set for requests served through CDN

	static async getStaticData(xookId: string) {
		const url = PUBLIC_URL + "/v3/xook/" + xookId + "/staticData";
		return await get({ url }, true);
	}

	static async getDynamicFoodData(xookId: string) {
		const url = PUBLIC_URL + "/v3/xook/" + xookId + "/menuDataAndAvailability";
		return await get({ url }, true);
	}

	static async getXookData(xookId: string) {
		const url = SERVER_URL + "/v1/xook/" + xookId + "/";
		return await get({ url });
	}
    
	static async getUpdatedDishPrice(data: any) {
		const url = SERVER_URL + "/v3/restaurant/calculatePrice";
		return await post({ url, data });
	}
    static async getAllergies() {
        const url = SERVER_URL + "/v3/user/allergens";
        return await get({ url });
    }

}

export default FoodService;
